// when a site is not SSO, this is substituted for sso-service to reduce unused js

export default {
  processSsoRegDone: (): void => { return },
  ssoCreateReview: (): void => { return },
  ssoCreateQuestion: (): void => { return },
  ssoCreateAnswer: (): void => { return },
  ssoCreateReply: (): void => { return },
  ssoGetLoggedInData: (): void => { return },
  ssoGetLoggedInDataForReview: (): void => { return },
  processLoggedInDataDone: (): void => { return },
  logout: (): void => { return }
}
